import { IconButton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import useOpenState from '../../../../hooks/useOpenState';
import { useDispatch, useSelector } from 'react-redux';
import { announcements, loadAnnouncements } from '../../../../store/reducers/announcement';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Badge from '@mui/material/Badge';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import { useTranslation } from 'react-i18next';
import InformationBox from '../../../../components/other/informationBox';
import { TimerCountUp } from '../../../../controls/agyle/timer';
import _, { isEmpty } from 'lodash';
import { Tooltip } from '@material-ui/core';
import { useHeaderIconStyles } from '../../../../components/patient/components/iconStyle';
import clsx from 'clsx';

const WardAlerts = ({ ward }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const classes = useHeaderIconStyles();
    const isMounted = useRef(true);

    // Announcements
    const announcementsObject = useSelector(announcements);
    const [filtered, setFiltered] = useState([]);

    const [isAlertsOpen, openAlerts, closeAlerts] = useOpenState(false, false);

    // Refresh Announcements every 1 minute
    useEffect(() => {
        dispatch(loadAnnouncements());
        const iid = setInterval(() => dispatch(loadAnnouncements()), 60000);
        return () => {
            isMounted.current = false;
            clearInterval(iid);
        };
    }, []);

    useEffect(() => {
        const filter = announcementsObject?.filter((a) => a.enabled && a.system !== 'UCR' && a.system !== 'ED WAIT') || [];
        setFiltered(filter);
    }, [announcementsObject]);

    const renderAnnouncement = (obj) => {
        const typeMap = {
            NOTE: 'tip',
            INFO: 'info',
            ERROR: 'error',
            WARNING: 'warning',
        };

        const type = typeMap[obj.colour] ?? 'info';

        return (
            <InformationBox type={type} key={obj?.id}>
                {obj?.text || ''}

                {obj?.counter && obj?.countdownTo && (
                    <TimerCountUp time={obj?.countdownTo} limit={0} upperLimit={1} limitMessage={t('Times out')} countDown />
                )}
            </InformationBox>
        );
    };

    return (
        <>
            <Tooltip title={t('Location Alerts')}>
                <IconButton
                    size="small"
                    onClick={openAlerts}
                    color={isAlertsOpen ? 'primary' : 'default'}
                    className={clsx(classes.iconHover, isAlertsOpen && classes.iconButton)}
                >
                    <Badge
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        max={9}
                        badgeContent={filtered?.length || 0}
                        color="primary"
                        sx={{ '& .MuiBadge-badge': { fontSize: 11, height: 15, minWidth: 15 } }}
                    >
                        <WarningAmberIcon />
                    </Badge>
                </IconButton>
            </Tooltip>

            {isAlertsOpen && (
                <AgyleDialog
                    title={t('Location Alerts')}
                    open={isAlertsOpen}
                    onClose={closeAlerts}
                    onSave={closeAlerts}
                    width="md"
                    fullWidth
                    disableActionsCloseButton
                    submitText={t('Acknowledge')}
                    closeButtonOnHeader
                >
                    <>
                        {filtered.map((a) => renderAnnouncement(a))}
                        {isEmpty(filtered) && <InformationBox type="info">{t('No active alerts at this time.')}</InformationBox>}
                    </>
                </AgyleDialog>
            )}
        </>
    );
};

export default WardAlerts;
